module.exports = __webpack_public_path__ + "img/card.0c39d719.svg";